import React from "react";
import reducer from "../reducers/Main";
import * as ACTIONS from "../actions/Main";
import { apiPath } from "../utils/api";
import { usePostHog } from "posthog-js/react";

export const MainStore = React.createContext(null);

const initialState = {
  appConfig: {
    onboarding_financials: "",
    onboarding_payment_options: "",
    onboarding_sentiment: "",
  },
  agencyDetails: {
    name: "",
    phone: "",
    disable_check: false,
    pemkey: "",
  },
  refCode: "",
  isAuthenticated: false,
  acceptedDisclosures: false,
  agency: false,
  userType: "",
  loginError: null,
  isLoggingIn: false,
  phoneVerified: false,
  questionnaire: false,
  sentimentQuestionnaire: false,
  agencyLinked: false,
  profile: {
    first_name: "",
    last_name: "",
    address: "",
    address2: "",
    city: "",
    state: "",
    postal_code: "",
    email: "",
    phone: "",
    allow_phone: false,
    allow_push: false,
    allow_sms: false,
    allow_email: false,
    emotional_score: 0,
    financial_score: 0,
    agency: {
      name: "",
      phone: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      phone_toll: "",
      phone_local: "",
      hours: "",
      optins: {
        allow_phone: false,
        allow_push: false,
        allow_sms: false,
        allow_esign: false,
      },
    },
    top_spending: [],
  },
  accounts: [],
  avatar:
    "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",
};

export function MainStoreProvider(props) {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const posthog = usePostHog();

  const doLogout = (main) => {
    let path = window.location.origin + apiPath + "/logout";
    if (main) path = path + "?main=true";
    posthog?.reset();
    window.history.replaceState(null, document.title, path);
    window.location.href = path;
  };

  const value = {
    refCode: state.refCode,
    avatar: state.avatar,
    profile: state.profile,
    userType: state.userType,
    appConfig: state.appConfig,
    acceptedDisclosures: state.acceptedDisclosures,
    phoneVerified: state.phoneVerified,
    isLoggingIn: state.isLoggingIn,
    isAuthenticated: state.isAuthenticated,
    agency: state.agency,
    agencyLinked: state.agencyLinked,
    agencyDetails: state.agencyDetails,
    questionnaire: state.questionnaire,
    sentimentQuestionnaire: state.sentimentQuestionnaire,
    loginError: state.loginError,
    accounts: state.accounts,
    setAgencyDetails: (details) =>
      dispatch(ACTIONS.SET_AGENCY_DETAILS(details)),
    setRefCode: (code) => dispatch(ACTIONS.SET_REFCODE(code)),
    setAppConfig: (cfg) => dispatch(ACTIONS.SET_APPCONFIG(cfg)),
    setProfile: (profile) => dispatch(ACTIONS.SET_PROFILE(profile)),
    setAccounts: (accounts) => dispatch(ACTIONS.SET_ACCOUNTS(accounts)),
    setAvatar: (base64) => dispatch(ACTIONS.SET_AVATAR(base64)),
    handleLoginSuccess: ({
      agency,
      userType,
      phoneVerified,
      questionnaire,
      sentimentQuestionnaire,
      agencyLinked,
    }) =>
      dispatch(
        ACTIONS.LOGIN_SUCCESS({
          agency,
          userType,
          phoneVerified,
          questionnaire,
          sentimentQuestionnaire,
          agencyLinked,
        })
      ),
    handleLoginFailure: (error) => dispatch(ACTIONS.LOGIN_FAILURE(error)),
    handleLogout: (main) => doLogout(main),
    handleAcceptDisc: () => dispatch(ACTIONS.ACCEPT_DISCLOSURES()),
    handlePhoneVerified: () => dispatch(ACTIONS.PHONE_VERIFIED()),
    handleQuestionnaire: () => dispatch(ACTIONS.QUESTIONNAIRE()),
    handleSentimentQuestionnaire: () =>
      dispatch(ACTIONS.SENTIMENT_QUESTIONNAIRE()),
    handleAgencyLinked: () => dispatch(ACTIONS.AGENCY_LINKED()),
  };

  return (
    <MainStore.Provider value={value}>{props.children}</MainStore.Provider>
  );
}
